import { useState, } from 'react';

import { Button, Form, Col, } from 'react-bootstrap';
import SearchIcon from '@material-ui/icons/Search';


function DateIntervalSelector({ onSubmit, }) {
  const [interval, setInterval] = useState({
    start: undefined,
    end: undefined,
  });


  function onChange(event) {
    setInterval({
      ...interval,
      [event.target.name]: event.target.value,
    });
  }


  return (
    <Form>
      <Form.Row>
        <Col sm={3}>
          <Form.Label>
            Data inicial
          </Form.Label>
          <Form.Control
            value={interval.start}
            type="date"
            size="lg"
            name="start"
            onChange={onChange}
          />
        </Col>

        <Col sm={3}>
          <Form.Label>
            Data final
          </Form.Label>
          <Form.Control
            value={interval.end}
            type="date"
            size="lg"
            name="end"
            onChange={onChange}
          />
        </Col>

        <Button
          onClick={() => onSubmit(interval)}
          variant=""
        >
          <SearchIcon />
        </Button>
      </Form.Row>
    </Form>
  );
}

export default DateIntervalSelector;
